// Autrona Acoustic Computer Program: Remote
// Connect to a remote terminal

import * as main from '../main.js';
import * as screen from '../kernel/screen.js';
import * as audio from '../kernel/audio.js';
import * as oblivion from '../programs/oblivion.js';

// Variables
let keyBoardResponsive = true;
let address;
let audioSource;

// Configuration
const dialUp = true;

// Game data
const addresses = {
    '10.1.2.3': oblivion,
};

function run(...args) {
    keyBoardResponsive = true;
    address = args[0] || '';

    screen.save();
    screen.clear();

    // Header
    screen.newLine();
    // Screen sequence. See screen.js comments for documentation
    const seq = [
        100, 'AutronaTerm v2.5 - 802.11', '!s:col-red', '!s:col-bg-red',
        100, '!n',
        100, '!n',
    ];
    screen.sequence(seq, () => {
        if (address) {
            screen.append('Connecting to ' + address);
            openConnection();
        } else {
            screen.append('Enter remote terminal address > ');
            screen.cursor();
        }
    });
}

function openConnection() {
    keyBoardResponsive = false;
    if (address in addresses) {

        if (dialUp) {
            // Play modem dial up sound
            audioSource = audio.buffers.play('dial-up-modem', {
                initialGain: -20,
            });

            // Screen sequence. See screen.js comments for documentation
            const seq = `
                §1000<opening line>
                §800<dialing ISP...>
                §4300<initiating connection...>
                §3900<negotiating modulation mode...>
                §3200<probing line...>
                §1400<adjusting equalizers...>

                §9200<connection established>

                §2200<muting modem>

                §500<remote tty override from ${address}>
            `.trim();
            screen.sequence2(seq, {
                color: ['col-dark-green', 'italic'],
                mode: 'line',
                lineDelay: 0,
                endDelay: 0,
            }, () => {
                setTimeout(() => {
                    stopSounds();
                    addresses[address].run(exit)
                }, 2000);
            });
        } else {
            screen.newLine();
            // Screen sequence. See screen.js comments for documentation
            const seq = [
                100, '!s:col-dark-green', '<initiating connection...>', '!n',
                5160, '!s:col-green', '<connection established>', '!n'
            ];
            screen.sequence(seq, () => {
                main.soundEffect('connected');
                setTimeout(() => {
                    stopSounds();
                    addresses[address].run(exit)
                }, 1000);
            });
        }
    } else {
        console.log('Bad address: ' + address);
        address = '';
        screen.newLine();
        // Screen sequence. See screen.js comments for documentation
        const seq = [
            100, '!s:col-dark-green', '<initiating connection...>', '!n',
            5160, '!s:col-dark-red', '<unable to reach host>', '!n',
            100, 'Enter remote terminal address > ',
        ];
        screen.sequence(seq, () => {
            main.soundEffect('error');
            screen.cursor();
            keyBoardResponsive = true;
        });
    }
}

function stopSounds() {
    if (audioSource) audioSource.stop();
}

function exit() {
    console.log('Remote program exit');
}

export { run };
